// https://material-ui.com/customization/typography/#self-hosted-fonts
import { FontFace } from 'csstype'

import RobotoBold from './assets/Roboto-Bold.ttf'
import RobotoRegular from './assets/Roboto-Regular.ttf'

export const robotoRegular: FontFace = {
  fontFamily: 'Roboto',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Roboto'),
    local('Roboto-Regular'),
    url(${RobotoRegular}) format('truetype')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

export const robotoBold: FontFace = {
  fontFamily: 'Roboto',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('Roboto-Bold'),
    url(${RobotoBold}) format('truetype')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

export const fonts = {
  primary: 'Roboto',
  secondary: 'Prompt',
  size: {
    xhuge: '36px',
    huge: '32px',
    xlarge: '24px',
    large: '20px',
    medium: '18px',
    base: '16px',
    small: '14px',
    xsmall: '12px',
    tiny: '10px',
  },
}
